import { Typography } from '@curology/ui-components-web/react/Typography';

const WeAreSorryMessage = () => {
  return (
    <Typography className="cur-m-4 cur-text-center" weight="bold">
      We&apos;re sorry, but a server error occurred. Please try refreshing your
      page.
    </Typography>
  );
};

export default WeAreSorryMessage;
